import React from "react";
import { getIr35Name } from "../helper";

export default function RowBookingType({ rowData }: { rowData: any }) {
  const ir35Name = getIr35Name(rowData?.booking?.ir35_code);
  return <span>{ir35Name}</span>;
}
